export const filterPrice = (val: number | null): string => {
  let temp = val
  if (typeof temp !== 'number') {
    temp = 0
  }
  return temp.toLocaleString('ru') + ' '
}
